var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 1.83394V11.0007H0V1.83394H4.58336V0.917268C4.58336 0.788361 4.60723 0.669003 4.65497 0.559193C4.70271 0.449384 4.76717 0.353897 4.84833 0.272734C4.92949 0.19157 5.02737 0.124729 5.14195 0.0722117C5.25654 0.0196941 5.37589 -0.00417754 5.50003 0.000596791H9.16671C9.29562 0.000596791 9.41498 0.0244684 9.52479 0.0722117C9.6346 0.119955 9.73008 0.184408 9.81125 0.265572C9.89241 0.346736 9.95925 0.444609 10.0118 0.559193C10.0643 0.673777 10.0882 0.793135 10.0834 0.917268V1.83394H14.6667ZM5.50003 1.83394H9.16671V0.917268H5.50003V1.83394ZM0.916671 2.75061V4.07549L5.50003 6.36V5.50062H9.16671V6.36L13.7501 4.07549V2.75061H0.916671ZM6.4167 6.41729V7.33397H8.25004V6.41729H6.4167ZM13.7501 10.084V5.09242L9.16671 7.39126V8.25064H5.50003V7.39126L0.916671 5.09242V10.084H13.7501Z",
    fill: "#07775D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.75d6cde2d639c462e96a127d0f0d380c.svg";
export { ForwardRef as ReactComponent };